const POST_FILTER = `_type == "post" && !(_id in path("drafts.**")) && publishedAt <= now()`

export const AUTHOR_PROJECTION = `{
  name,
  slug,
  role,
  bio,
  twitter,
  linkedin,
  github,
  website,
  email,
  photo { asset, hotspot, "width": asset->metadata.dimensions.width, "height": asset->metadata.dimensions.height }
}`

export const COAUTHOR_PROJECTION = `{
  name,
  slug,
  role,
  photo { asset, hotspot, "width": asset->metadata.dimensions.width, "height": asset->metadata.dimensions.height }
}`

export const postCardFields = `
  _id,
  title,
  slug,
  publishedAt,
  excerpt,
  category,
  tags,
  "author": author-> ${AUTHOR_PROJECTION},
  "coAuthors": coAuthors[]-> ${COAUTHOR_PROJECTION},
  coverImage { asset, alt, hotspot, "width": asset->metadata.dimensions.width, "height": asset->metadata.dimensions.height }
`

export const postWithRelatedQuery = `
  *[${POST_FILTER} && slug.current == $slug][0] {
    ${postCardFields},
    body,
    _updatedAt,
    seo {
      metaTitle,
      metaDescription,
      ogImage { asset, alt, "width": asset->metadata.dimensions.width, "height": asset->metadata.dimensions.height }
    },
    "relatedPosts": relatedPosts[]->[${POST_FILTER}] {
      ${postCardFields}
    }[defined(_id)]
  }
`
